import React, {useState} from 'react';
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { imagesWildlife } from '../assets/wildlifeImages';

const WildlifeGallery = () => {
  
    const [index, setIndex] = useState(-1);

    const currentImage = imagesWildlife[index];
    const nextIndex = (index + 1) % imagesWildlife.length;
    const nextImage = imagesWildlife[nextIndex] || currentImage;
    const prevIndex = (index + imagesWildlife.length - 1) % imagesWildlife.length;
    const prevImage = imagesWildlife[prevIndex] || currentImage;
  
    const handleClick = (index) => {
      setIndex(index);
    }
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);  
 return (
        <div>   
        <Gallery 
          images={imagesWildlife} 
          onClick={handleClick} 
          enableImageSelection={false}
        />
        {!!currentImage && (
          <Lightbox
            mainSrc={currentImage.original}
            imageTitle={currentImage.caption}
            mainSrcThumbnail={currentImage.src}
            nextSrc={nextImage.original}
            nextSrcThumbnail={nextImage.src}
            prevSrc={prevImage.original}
            prevSrcThumbnail={prevImage.src}
            onCloseRequest={handleClose}
            onMovePrevRequest={handleMovePrev}
            onMoveNextRequest={handleMoveNext}
          />
        )}
        </div> 
    );

};

export default WildlifeGallery;